import { useState } from 'react';

interface AlertState {
  show: boolean;
  type: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  message: string;
}

export const useAlert = () => {
  const [alert, setAlert] = useState<AlertState>({
    show: false,
    type: 'info',
    title: '',
    message: ''
  });

  const showSuccess = (title: string, message: string) => {
    setAlert({ show: true, type: 'success', title, message });
  };

  const showError = (title: string, message: string) => {
    setAlert({ show: true, type: 'error', title, message });
  };

  const showWarning = (title: string, message: string) => {
    setAlert({ show: true, type: 'warning', title, message });
  };

  const showInfo = (title: string, message: string) => {
    setAlert({ show: true, type: 'info', title, message });
  };

  const hideAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  return {
    alert,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    hideAlert
  };
};